import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./pop-up.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./pop-up.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../app-controller.service";
import { SharedConstants } from "../../constants/shared.constants";
import { AppConfig } from "src/app/app.config";
let PopUpComponent = class PopUpComponent {
    activeModal;
    appController;
    title;
    contentMessage;
    data;
    updateBtnPlaceholder = SharedConstants.YES_LABEL;
    cancelBtnPlaceholder = SharedConstants.NO_LABEL;
    hideCancelBtn = false;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    constructor(activeModal, appController) {
        this.activeModal = activeModal;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    onBtnOkClick() {
        this.activeModal.close(this.data);
    }
    onBtnCancel() {
        this.activeModal.close();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService }
    ];
    static propDecorators = {
        title: [{ type: Input }],
        contentMessage: [{ type: Input }],
        data: [{ type: Input }],
        updateBtnPlaceholder: [{ type: Input }],
        cancelBtnPlaceholder: [{ type: Input }],
        hideCancelBtn: [{ type: Input }]
    };
};
PopUpComponent = __decorate([
    Component({
        selector: "app-pop-up.component",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], PopUpComponent);
export { PopUpComponent };
